import { CultureInfo } from '../culture-info.model';
import { CultureInfoFfLatn } from './ff-Latn';

/**
 * @ignore
 */
export const CultureInfoFfLatnMR: CultureInfo = {
  name: 'ff-Latn-MR',
  displayName: 'Pulaar (Latn, Muritani)',
  iso3LanguageCode: 'ful',
  iso2LanguageCode: 'ff',
  ietfLanguageTag: 'ff-Latn-MR',
  parent: CultureInfoFfLatn
};
